import { render } from "./TimeSetting.vue?vue&type=template&id=72b7b84f&scoped=true"
import script from "./TimeSetting.vue?vue&type=script&lang=js"
export * from "./TimeSetting.vue?vue&type=script&lang=js"

import "./TimeSetting.vue?vue&type=style&index=0&id=72b7b84f&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b7b84f"]])

export default __exports__